<template>
    <!-- <div id="portfolio-section">
        <h1>Portafolio</h1>
    </div> -->
    <div id="portfolio-section" class="section-port space-section">

      <b-row class="justify-content-center">
        <b-col cols="12" sm="12" md="12" lg="12" xl="10">
          <div class="space50">
            <h5 class="text-center gotham-med tm-title">{{ $t('header.portfolio') }}</h5>
          </div>
        </b-col>
      </b-row>

            <!-- <nav class="mynav scrollmenu letter-book"> -->
            <vue-scroll :ops="menuscroll" >
              <nav class="mynav scrollmenu letter-book">

                  <a id="nav0" class="active"  @click="mostrar(0)">{{ $t('portfolio.all') }}</a>
                  <a id="nav1" @click="mostrar(1)">{{ $t('portfolio.branding') }}</a>
                  <a id="nav2" @click="mostrar(2)">{{ $t('portfolio.motion') }}</a>
                  <a id="nav4" @click="mostrar(4)">{{ $t('portfolio.managment') }}</a>
                  <a id="nav5" @click="mostrar(5)">{{ $t('portfolio.design-serv') }}</a>
                  <a id="nav6" @click="mostrar(6)">{{ $t('portfolio.interface') }}</a>
              </nav>
            </vue-scroll>
          <div class="target animate__animated animate__fadeInLeft"></div>
          

          <!-- <b-container> -->
            <b-row>
              <div style="width:100%; text-align:center">
                <br>
                <p :style="{display:show}">{{ $t('portfolio.empty') }}</p>
              </div>
            </b-row>
            <div class="panel-scroll">
            <vue-scroll :ops="ops" > 
              <div id="gallery-content" :class="[animation,animateDirection]">
                <div class="gallery-container">
                  <div class="gallery_item brand proyecto">
                    <!-- <img src="../assets/img/projects/placeholder/1-ExitusCredit.jpg" class="gallery__img" alt=""> -->
                    <img v-lazy="imgUrl1" class="gallery__img" alt="ExitusCredit">
                    <div class="over-proyecto over-l">
                        <p class="name-project p-info-l">{{$t('portfolio.exitus')}}</p>
                        <p class="name-service">{{$t('portfolio.branding')}}</p>
                        <p class="name-service">{{$t('portfolio.interface')}}</p>
                    </div>
                  </div>

                  <div class="gallery_item interface managment proyecto">
                    <!-- <img src="../assets/img/projects/placeholder/2-ExitusCreditUX_UI.jpg"  loading="lazy" class="gallery__img" alt=""> -->
                    <img v-lazy="imgUrl2" class="gallery__img" alt="ExitusUx">
                    <div class="over-proyecto over-s">
                    <p class="name-project p-info-s">{{$t('portfolio.exitusUI')}}</p>
                    <p class="name-service">{{$t('portfolio.interface')}}</p>
                    <p class="name-service">{{$t('portfolio.managment')}}</p>
                  </div>
                    
                  </div>

                  <div class="gallery_item brand design-serv proyecto">
                    <!-- <img src="../assets/img/projects/placeholder/3-ExitusCreditContenido.jpg" class="gallery__img" alt=""> -->
                    <img v-lazy="imgUrl3" class="gallery__img" alt="ExitusContent">
                    <div class="over-proyecto over-l">
                    <p class="name-project p-info-l">{{$t('portfolio.exitusContent')}}</p>
                    <p class="name-service">{{$t('portfolio.branding')}}</p>
                    <p class="name-service">{{$t('portfolio.design-serv')}}</p>
                    
                  </div>
                  </div>

                  <div class="gallery_item brand managment proyecto">
                    <!-- <img src="../assets/img/projects/placeholder/5-ExitusMujer.jpg" class="gallery__img" alt=""> -->
                    <img v-lazy="imgUrl4" class="gallery__img" alt="ExitusMujer">
                    <div class="over-proyecto over-l">
                      <p class="name-project p-info-l">{{$t('portfolio.exitusMujer')}}</p>
                      <p class="name-service">{{$t('portfolio.branding')}}</p>
                      <p class="name-service">{{$t('portfolio.managment')}}</p>
                    </div>
                  </div>

                  <div class="gallery_item interface proyecto">
                    <!-- <img src="../assets/img/projects/placeholder/4-ExitusForce.jpg" class="gallery__img" alt=""> -->
                    <img v-lazy="imgUrl5" class="gallery__img" alt="ExitusForce">
                    <div class="over-proyecto over-s">
                      <p class="name-project p-info-s">{{$t('portfolio.exitusForce')}}</p>
                      <p class="name-service">{{$t('portfolio.interface')}}</p>
                    </div>
                  </div>

                  <div class="gallery_item brand managment proyecto">
                    <!-- <img src="../assets/img/projects/placeholder/6-iBillete.jpg" class="gallery__img" alt=""> -->
                    <img v-lazy="imgUrl6" class="gallery__img" alt="Ibillete">
                     <div class="over-proyecto over-s">
                      <p class="name-project p-info-s">{{$t('portfolio.ibillete')}}</p>
                      <p class="name-service">{{$t('portfolio.branding')}}</p>
                      <p class="name-service">{{$t('portfolio.managment')}}</p>
                    </div>
                  </div>

                  <div class="gallery_item brand interface proyecto">
                    <!-- <img src="../assets/img/projects/placeholder/7-WhiteCarrot.jpg" class="gallery__img" alt=""> -->
                    <img v-lazy="imgUrl7" class="gallery__img" alt="Carrot">
                    <div class="over-proyecto over-l">
                      <p class="name-project p-info-l">{{$t('portfolio.carrot')}}</p>
                      <p class="name-service">{{$t('portfolio.branding')}}</p>
                      <p class="name-service">{{$t('portfolio.interface')}}</p>
                    </div>
                  </div>

                  <div class="gallery_item brand interface proyecto">
                    <!-- <img src="../assets/img/projects/placeholder/8-iBilleteUX.jpg" class="gallery__img" alt=""> -->
                    <img v-lazy="imgUrl8" class="gallery__img" alt="IbilleteUx">
                    <div class="over-proyecto over-s">
                      <p class="name-project p-info-s">{{$t('portfolio.ibilleteUX')}}</p>
                      <p class="name-service">{{$t('portfolio.interface')}}</p>
                    </div>
                  </div>

                  <div class="gallery_item interface proyecto">
                    <!-- <img src="../assets/img/projects/placeholder/9-VenueInsights.jpg" class="gallery__img" alt=""> -->
                    <img v-lazy="imgUrl9" class="gallery__img" alt="Venue">
                    <div class="over-proyecto over-l">
                      <p class="name-project p-info-l">{{$t('portfolio.venue')}}</p>
                      <p class="name-service">{{$t('portfolio.interface')}}</p>
                    </div>
                  </div>


                  <div class="gallery_item interface proyecto">
                    <!-- <img src="../assets/img/projects/placeholder/11-EnterpriseConnect.jpg" class="gallery__img" alt=""> -->
                    <img v-lazy="imgUrl10" class="gallery__img" alt="Enterprice">
                    <div class="over-proyecto over-s">
                      <p class="name-project p-info-s">{{$t('portfolio.enterprise')}}</p>
                      <p class="name-service">{{$t('portfolio.interface')}}</p>
                    </div>
                  </div>

                  <div class="gallery_item brand proyecto">
                    <!-- <img src="../assets/img/projects/placeholder/10-EXOS.jpg" class="gallery__img" alt=""> -->
                    <img v-lazy="imgUrl11" class="gallery__img" alt="Exos">
                    <div class="over-proyecto over-s">
                      <p class="name-project p-info-s">{{$t('portfolio.exos')}}</p>
                      <p class="name-service">{{$t('portfolio.branding')}}</p>
                    </div>
                  </div>

                  <div class="gallery_item interface proyecto">
                    <!-- <img src="../assets/img/projects/placeholder/14-eBind.jpg" class="gallery__img" alt=""> -->
                    <img v-lazy="imgUrl12" class="gallery__img" alt="Ebind">
                    <div class="over-proyecto over-l">
                      <p class="name-project p-info-l">{{$t('portfolio.ebind')}}</p>
                      <p class="name-service">{{$t('portfolio.interface')}}</p>
                    </div>
                  </div>

                  <div class="gallery_item design-serv proyecto">
                    <!-- <img src="../assets/img/projects/placeholder/12-EXOSPresent.jpg" class="gallery__img" alt=""> -->
                    <img v-lazy="imgUrl13" class="gallery__img" alt="ExosPresent">
                    <div class="over-proyecto over-s">
                      <p class="name-project p-info-s">{{$t('portfolio.exosPresent')}}</p>
                      <p class="name-service">{{$t('portfolio.design-serv')}}</p>
                    </div>
                  </div>
                  <div class="gallery_item design-serv proyecto">
                    <!-- <img src="../assets/img/projects/placeholder/13-CSA.jpg" class="gallery__img" alt=""> -->
                    <img v-lazy="imgUrl14" class="gallery__img" alt="CSA">
                    <div class="over-proyecto over-s">
                      <p class="name-project p-info-s">{{$t('portfolio.csa')}}</p>
                      <p class="name-service">{{$t('portfolio.design-serv')}}</p>
                    </div>
                  </div>
                  
                  <div class="gallery_item interface proyecto">
                    <!-- <img src="../assets/img/projects/placeholder/15-SMS.jpg" class="gallery__img" alt=""> -->
                    <img v-lazy="imgUrl15" class="gallery__img" alt="SMS">
                    <div class="over-proyecto over-s">
                      <p class="name-project p-info-s">{{$t('portfolio.sms')}}</p>
                      <p class="name-service">{{$t('portfolio.interface')}}</p>
                    </div>
                  </div>
                  <div class="gallery_item interface proyecto">
                    <!-- <img src="../assets/img/projects/placeholder/16-TelmexConnect.jpg" class="gallery__img" alt=""> -->
                    <img v-lazy="imgUrl16" class="gallery__img" alt="Telmex">
                    <div class="over-proyecto over-l">
                      <p class="name-project p-info-l">{{$t('portfolio.telmex')}}</p>
                      <p class="name-service">{{$t('portfolio.interface')}}</p>
                    </div>
                  </div>
                  <div class="gallery_item interface proyecto">
                    <!-- <img src="../assets/img/projects/placeholder/17-SHIFT.jpg" class="gallery__img" alt=""> -->
                    <img v-lazy="imgUrl17" class="gallery__img" alt="Shift">
                     <div class="over-proyecto over-s">
                      <p class="name-project p-info-s">{{$t('portfolio.shift')}}</p>
                      <p class="name-service">{{$t('portfolio.interface')}}</p>
                    </div>
                  </div>
                  <div class="gallery_item design-serv proyecto">
                    <!-- <img src="../assets/img/projects/placeholder/18-PROSAPresent.jpg" class="gallery__img" alt=""> -->
                    <img v-lazy="imgUrl18" class="gallery__img" alt="ProsaPresent">
                    <div class="over-proyecto over-s">
                      <p class="name-project p-info-s">{{$t('portfolio.prosaPresent')}}</p>
                      <p class="name-service">{{$t('portfolio.design-serv')}}</p>
                    </div>
                  </div>
                  
                  <div class="gallery_item interface proyecto">
                    <!-- <img src="../assets/img/projects/placeholder/20-SMS_1.jpg" class="gallery__img" alt=""> -->
                    <img v-lazy="imgUrl19" class="gallery__img" alt="SMSUX">
                    <div class="over-proyecto over-s">
                      <p class="name-project p-info-s">{{$t('portfolio.smsUX')}}</p>
                      <p class="name-service">{{$t('portfolio.interface')}}</p>
                    </div>
                  </div>

                  <div class="gallery_item interface proyecto">
                    <!-- <img src="../assets/img/projects/placeholder/21-CRN.jpg" class="gallery__img" alt=""> -->
                    <img v-lazy="imgUrl20" class="gallery__img" alt="CRN">
                    <div class="over-proyecto over-l">
                      <p class="name-project p-info-l">{{$t('portfolio.crn')}}</p>
                      <p class="name-service">{{$t('portfolio.interface')}}</p>
                    </div>
                  </div>

                  <div class="gallery_item motion proyecto">
                    <!-- <img src="../assets/img/projects/placeholder/19-DCC.jpg" class="gallery__img" alt=""> -->
                    <img v-lazy="imgUrl21" class="gallery__img" alt="DCC">
                    <div class="over-proyecto over-s">
                      <p class="name-project p-info-s">{{$t('portfolio.dcc')}}</p>
                      <p class="name-service">{{$t('portfolio.motion')}}</p>
                    </div>
                  </div>

                   <div class="gallery_item design-serv proyecto">
                    <!-- <img src="../assets/img/projects/placeholder/23-MUTAMX.jpg" class="gallery__img" alt=""> -->
                    <img v-lazy="imgUrl22" class="gallery__img" alt="MUTA">
                    <div class="over-proyecto over-s">
                      <p class="name-project p-info-s">{{$t('portfolio.muta')}}</p>
                      <p class="name-service">{{$t('portfolio.design-serv')}}</p>
                    </div>
                  </div>


                  <div class="gallery_item motion design-serv proyecto">
                    <!-- <img src="../assets/img/projects/placeholder/22-ContenidouHaven.jpg" class="gallery__img" alt=""> -->
                    <img v-lazy="imgUrl23" class="gallery__img" alt="UhavenContent">
                    <div class="over-proyecto over-l">
                      <p class="name-project p-info-l">{{$t('portfolio.uhavenContent')}}</p>
                      <p class="name-service">{{$t('portfolio.motion')}}</p>
                      <p class="name-service">{{$t('portfolio.design-serv')}}</p>
                    </div>
                  </div>

                  <div class="gallery_item interface proyecto">
                    <!-- <img src="../assets/img/projects/placeholder/26-uHaven.jpg" class="gallery__img" alt=""> -->
                    <img v-lazy="imgUrl24" class="gallery__img" alt="Uhaven">
                    <div class="over-proyecto over-l">
                      <p class="name-project p-info-l">{{$t('portfolio.uhaven')}}</p>
                      <p class="name-service">{{$t('portfolio.interface')}}</p>
                    </div>
                  </div>

                  <div class="gallery_item brand proyecto">
                    <!-- <img src="../assets/img/projects/placeholder/24-uhavenBranding.jpg" class="gallery__img" alt=""> -->
                    <img v-lazy="imgUrl25" class="gallery__img" alt="UhavenBrand">
                    <div class="over-proyecto over-s">
                      <p class="name-project p-info-s">{{$t('portfolio.uhavenBrand')}}</p>
                      <p class="name-service">{{$t('portfolio.branding')}}</p>
                    </div>
                  </div>
                  
                  <div class="gallery_item interface proyecto">
                    <!-- <img src="../assets/img/projects/placeholder/27-SEND.jpg" class="gallery__img" alt=""> -->
                    <img v-lazy="imgUrl26" class="gallery__img" alt="Send">
                    <div class="over-proyecto over-s">
                      <p class="name-project p-info-s">{{$t('portfolio.send')}}</p>
                      <p class="name-service">{{$t('portfolio.interface')}}</p>
                    </div>
                  </div>

                  <div class="gallery_item design-serv proyecto">
                    <!-- <img src="../assets/img/projects/placeholder/25-PROASA.jpg" class="gallery__img" alt=""> -->
                    <img v-lazy="imgUrl27" class="gallery__img" alt="PROASA">
                    <div class="over-proyecto over-s">
                      <p class="name-project p-info-s">{{$t('portfolio.proasa')}}</p>
                      <p class="name-service">{{$t('portfolio.design-serv')}}</p>
                    </div>
                  </div>

                  <div class="gallery_item interface proyecto">
                    <!-- <img src="../assets/img/projects/placeholder/29-SpendAlerts.jpg" class="gallery__img" alt=""> -->
                    <img v-lazy="imgUrl28" class="gallery__img" alt="spend">
                    <div class="over-proyecto over-s">
                      <p class="name-project p-info-s">{{$t('portfolio.spend')}}</p>
                      <p class="name-service">{{$t('portfolio.interface')}}</p>
                    </div>
                  </div>

                  <div class="gallery_item interface proyecto">
                    <!-- <img src="../assets/img/projects/placeholder/30-MiControl.jpg" class="gallery__img" alt=""> -->
                    <img v-lazy="imgUrl29" class="gallery__img" alt="BNCR">
                    <div class="over-proyecto over-l">
                      <p class="name-project p-info-l">{{$t('portfolio.bncr')}}</p>
                      <p class="name-service">{{$t('portfolio.interface')}}</p>
                    </div>
                  </div>
                  
                  <div class="gallery_item interface proyecto">
                    <!-- <img src="../assets/img/projects/placeholder/28-ArubaConnect.jpg" class="gallery__img" alt=""> -->
                    <img v-lazy="imgUrl30" class="gallery__img" alt="ARUBA">
                    <div class="over-proyecto over-s">
                      <p class="name-project p-info-s">{{$t('portfolio.aruba')}}</p>
                      <p class="name-service">{{$t('portfolio.interface')}}</p>
                    </div>
                  </div>

                  <div class="gallery_item design-serv proyecto">
                    <!-- <img src="../assets/img/projects/placeholder/32-LungFlute.jpg" class="gallery__img" alt=""> -->
                    <img v-lazy="imgUrl31" class="gallery__img" alt="LUNG">
                    <div class="over-proyecto over-s">
                      <p class="name-project p-info-s">{{$t('portfolio.lung')}}</p>
                      <p class="name-service">{{$t('portfolio.design-serv')}}</p>
                    </div>
                  </div>
                  
                  
                  <div class="gallery_item design-serv brand proyecto">
                    <!-- <img src="../assets/img/projects/placeholder/31-VEQCapital.jpg" class="gallery__img" alt=""> -->
                    <img v-lazy="imgUrl32" class="gallery__img" alt="Procontet">
                    <div class="over-proyecto over-s">
                      <p class="name-project p-info-s">{{$t('portfolio.proasaContent')}}</p>
                      <p class="name-service">{{$t('portfolio.design-serv')}}</p>
                      <p class="name-service">{{$t('portfolio.branding')}}</p>
                    </div>
                  </div>

                  <div class="gallery_item interface proyecto">
                    <!-- <img src="../assets/img/projects/placeholder/35-MobileTPV.jpg" class="gallery__img" alt=""> -->
                    <img v-lazy="imgUrl33" class="gallery__img" alt="mobile">
                    <div class="over-proyecto over-s">
                      <p class="name-project p-info-s">{{$t('portfolio.mobile')}}</p>
                      <p class="name-service">{{$t('portfolio.interface')}}</p>
                    </div>
                  </div>
                  
                  <div class="gallery_item design-serv proyecto">
                    <!-- <img src="../assets/img/projects/placeholder/33-CloudPOS.jpg" class="gallery__img" alt=""> -->
                    <img v-lazy="imgUrl34" class="gallery__img" alt="cloud">
                    <div class="over-proyecto over-s">
                      <p class="name-project p-info-s">{{$t('portfolio.cloud')}}</p>
                      <p class="name-service">{{$t('portfolio.design-serv')}}</p>
                    </div>
                  </div>

                  <div class="gallery_item motion proyecto">
                    <!-- <img src="../assets/img/projects/placeholder/34-audioVEQ.jpg" class="gallery__img" alt=""> -->
                    <img v-lazy="imgUrl35" class="gallery__img" alt="VEQAudio">
                    <div class="over-proyecto over-s">
                      <p class="name-project p-info-s">{{$t('portfolio.veqAudio')}}</p>
                      <p class="name-service">{{$t('portfolio.motion')}}</p>
                    </div>
                  </div>
                  
                  <div class="gallery_item design-serv proyecto">
                    <!-- <img src="../assets/img/projects/placeholder/37-CapitalPresent.jpg" class="gallery__img" alt=""> -->
                    <img v-lazy="imgUrl36" class="gallery__img" alt="VEQ">
                    <div class="over-proyecto over-l">
                      <p class="name-project p-info-l">{{$t('portfolio.veq')}}</p>
                      <p class="name-service">{{$t('portfolio.design-serv')}}</p>
                    </div>
                  </div>

                  <div class="gallery_item brand proyecto">
                    <!-- <img src="../assets/img/projects/placeholder/36-SportsCapital.jpg" class="gallery__img" alt=""> -->
                    <img v-lazy="imgUrl37" class="gallery__img" alt="Sports">
                      <div class="over-proyecto over-s">
                      <p class="name-project p-info-s">{{$t('portfolio.sports')}}</p>
                      <p class="name-service">{{$t('portfolio.branding')}}</p>
                    </div>
                  </div>
                
                </div>

              </div>

              </vue-scroll>
            <div>
            </div>
          </div>
    </div>
</template>

<script>
export default {
  name: 'Portfolio',
  data(){
    return{
      show:"none",
      animation:"",
      animateDirection: "",
      posicion:0,
      dataimg:"../assets/img/projects/placeholder/36-SportsCapital.jpg",
      imgUrl1:require("../assets/img/projects/placeholder/1-ExitusCredit.jpg"),
      imgUrl2: require("../assets/img/projects/placeholder/2-ExitusCreditUX_UI.jpg"),
      imgUrl3: require("../assets/img/projects/placeholder/3-ExitusCreditContenido.jpg"),
      imgUrl4: require("../assets/img/projects/placeholder/5-ExitusMujer.jpg"),
      imgUrl5: require("../assets/img/projects/placeholder/4-ExitusForce.jpg"),
      imgUrl6: require("../assets/img/projects/placeholder/6-iBillete.jpg"),
      imgUrl7: require("../assets/img/projects/placeholder/7-WhiteCarrot.jpg"),
      imgUrl8: require("../assets/img/projects/placeholder/8-iBilleteUX.jpg"),
      imgUrl9: require("../assets/img/projects/placeholder/9-VenueInsights.jpg"),
      imgUrl10: require("../assets/img/projects/placeholder/11-EnterpriseConnect.jpg"),
      imgUrl11: require("../assets/img/projects/placeholder/10-EXOS.jpg"),
      imgUrl12: require("../assets/img/projects/placeholder/14-eBind.jpg"),
      imgUrl13: require("../assets/img/projects/placeholder/12-EXOSPresent.jpg"),
      imgUrl14: require("../assets/img/projects/placeholder/13-CSA.jpg"),
      imgUrl15: require("../assets/img/projects/placeholder/15-SMS.jpg"),
      imgUrl16: require("../assets/img/projects/placeholder/16-TelmexConnect.jpg"),
      imgUrl17: require("../assets/img/projects/placeholder/17-SHIFT.jpg"),
      imgUrl18: require("../assets/img/projects/placeholder/18-PROSAPresent.jpg"),
      imgUrl19: require("../assets/img/projects/placeholder/20-SMS_1.jpg"),
      imgUrl20: require("../assets/img/projects/placeholder/21-CRN.jpg"),
      imgUrl21: require("../assets/img/projects/placeholder/19-DCC.jpg"),
      imgUrl22: require("../assets/img/projects/placeholder/23-MUTAMX.jpg"),
      imgUrl23: require("../assets/img/projects/placeholder/22-ContenidouHaven.jpg"),
      imgUrl24: require("../assets/img/projects/placeholder/26-uHaven.jpg"),
      imgUrl25: require("../assets/img/projects/placeholder/24-uhavenBranding.jpg"),
      imgUrl26: require("../assets/img/projects/placeholder/27-SEND.jpg"),
      imgUrl27: require("../assets/img/projects/placeholder/25-PROASA.jpg"),
      imgUrl28: require("../assets/img/projects/placeholder/29-SpendAlerts.jpg"),
      imgUrl29: require("../assets/img/projects/placeholder/30-MiControl.jpg"),
      imgUrl30: require("../assets/img/projects/placeholder/28-ArubaConnect.jpg"),
      imgUrl31: require("../assets/img/projects/placeholder/32-LungFlute.jpg"),
      imgUrl32: require("../assets/img/projects/placeholder/31-VEQCapital.jpg"),
      imgUrl33: require("../assets/img/projects/placeholder/35-MobileTPV.jpg"),
      imgUrl34: require("../assets/img/projects/placeholder/33-CloudPOS.jpg"),
      imgUrl35: require("../assets/img/projects/placeholder/34-audioVEQ.jpg"),
      imgUrl36: require("../assets/img/projects/placeholder/37-CapitalPresent.jpg"),
      imgUrl37: require("../assets/img/projects/placeholder/36-SportsCapital.jpg"),

      ops: {
          vuescroll: {
            mode: 'native',
            sizeStrategy: 'percent',
            detectResize: true
          },
          scrollPanel: {
            initialScrollY: false,
            initialScrollX: false,
            scrollingX: false,
            scrollingY: true,
            speed: 500,
            easing: undefined,
            verticalNativeBarPos: 'right'
          },
          rail: {
            background: '#01a99a',
            opacity: 0,
            size: '6px',
            specifyBorderRadius: false,
            gutterOfEnds: null,
            gutterOfSide: '3px',
            keepShow: false
          },
          bar: {
            showDelay: 500,
            onlyShowBarOnScroll: true,
            keepShow: false,
            background: '#2ABECC',
            opacity: 1,
            hoverStyle: false,
            specifyBorderRadius: false,
            minSize: 0,
            size: '6px',
            disable: false
          }
      },
    menuscroll: {
          vuescroll: {
            mode: 'native',
            sizeStrategy: 'percent',
            detectResize: true
          },
          scrollPanel: {
            initialScrollY: false,
            initialScrollX: false,
            scrollingX: true,
            scrollingY: false,
            speed: 400,
            easing: undefined,
          },
          rail: {
            background: '#01a99a',
            opacity: 0,
            size: '5px',
            specifyBorderRadius: false,
            gutterOfEnds: '0px',
            gutterOfSide: '2px',
            keepShow: false
          },
          bar: {
            showDelay: 500,
            onlyShowBarOnScroll: true,
            keepShow: false,
            background: '#2ABECC',
            opacity: 1,
            hoverStyle: false,
            specifyBorderRadius: false,
            minSize: '.1',
            size: '5px',
            disable: false
          }
      }
    }
  },
  methods:{
    mostrar(clase){

      //FUNCIONES PARA MOSTRAR ANIMACIÓN EN NAV ------------------------------------------------

        const links = document.querySelectorAll(".mynav a");
        const target = document.querySelector(".target");
        let element=document.querySelector("#nav"+clase);
        for (let i = 0; i < links.length; i++) {
            if (links[i].classList.contains("active")) {
              links[i].classList.remove("active");
              links[i].classList.remove("active-col");
            }
            links[i].style.opacity = "1"; //tenia 0.95
          }

          element.classList.add("active");
          element.classList.add("active-col");
          element.style.opacity = "1";

          const width = (element.getBoundingClientRect().width-58);
          const left = (element.getBoundingClientRect().left + window.pageXOffset+27);

          target.style.width = `${width}px`;
          target.style.left = `${left}px`;
          target.style.transition="all .4s ease-in-out";
          target.style.top=`${top}px`;
      //----------------------------------------------------------------------------------------
      this.animation="";
      this.animateDirection="";
      // let row = document.querySelectorAll("#row-content");
      let row = document.querySelector("#gallery-content");
      // row.style="display:none";

      var clas;
      // let imgs = document.querySelectorAll(".proyecto");
      let imgs = document.querySelectorAll(".gallery_item");

      this.show="none";
      console.log(this.posicion);

      if(this.posicion>clase){
        this.animation="animate__animated";
        this.animateDirection= "animate__fadeInLeft";
        // row.classList.add(this.animation, this.animateDirection);
      }
      if(this.posicion<clase){
        this.animation="animate__animated";
        this.animateDirection="animate__fadeInRight";
        // row.classList.add(this.animation, this.animateDirection);
      }

      row.addEventListener('animationend', () => {
        // if(this.fadeRight==="animate__fadeOutRight"){
          this.animation="";
          this.animateDirection="";
        
      });
  
      // let rowImage = document.querySelectorAll(".row-image");
      if(clase===1){
        clas="brand";

        //AQUI COLOCAR PARA DETERMINAR TAMAÑO DE PANTALLA Y PONER EL PANEL GRIS DE ACUERDO A LOS ITEMS
        // for (const rowI of rowImage) {
        //   rowI.style.height="1200px";
        // }
        this.posicion=1;
      }
      if(clase===2){
        clas="motion"
        // for (const rowI of rowImage) {
        //   rowI.style.height="700px";
        // }
        this.posicion=2;
      }
      if(clase===3){
        clas="experience"
        this.posicion=3;
      }

      if(clase===4){
        clas="managment";
        
        this.posicion=4;
      }
      if(clase===5){
        clas="design-serv"
        this.posicion=5;
      }
      if(clase===6){
        clas="interface"
        this.posicion=6;
      }

      if(clase===7){
        clas="story"
        this.posicion=7;
      }
      if(clase===0){
        this.posicion=0;
        for (const img of imgs) {
          img.style="display: block";
          row.style="display:block";
        }
      }
      else{
        for (const img of imgs) {
          img.style="display: none";
        }
        
        let img_brand= document.querySelectorAll("."+clas);
        console.log("clase a mostrar:" +clas);
        if(img_brand.length===0){

          this.show="block";
          row.style="display:block";
          // console.log(this.empty);
        }
        for (const img of img_brand) {
          img.style="display:block";
          row.style="display:block";
        }
      }

      

    }
  },
  mounted(){

    // if ('loading' in HTMLImageElement.prototype) {    // Si el navegador soporta lazy-load, tomamos todas las imágenes que tienen la clase    // `lazyload`, obtenemos el valor de su atributo `data-src` y lo inyectamos en el `src`.    const images = document.querySelectorAll("img.lazyload");
    //   // const images = document.querySelectorAll("img.img-lazy");
    //   // images.forEach(img => {
    //   //   this.dataimg=img.dataset.src
    //   //     // img.src = require(img.dataset.src);
    //   //     // console.log(img);

    //   // });
    //   console.log("SE SOPORTA EL LOADING LAZY");
    // } else {
    //   // Importamos dinámicamente la libreria `lazysizes`
    //   console.log("NO SE SOPORTA EL LOADING LAZY");
    //   let script = document.createElement("script");
    //   script.async = true;
    //   script.src = "https://cdnjs.cloudflare.com/ajax/libs/lazysizes/5.2.0/lazysizes.min.js";
    //   document.body.appendChild(script);
    // }

    const target = document.querySelector(".target");
    const links = document.querySelectorAll(".mynav a");

    for (let i = 0; i < links.length; i++) {
      // links[i].addEventListener("click", (e) => e.preventDefault());
      links[i].addEventListener("mouseenter", mouseenterFunc);
      links[i].addEventListener('mouseout', mouseOutFunction);
      // links[i].addEventListener("touchstart", mouseenterFunc);
      // links[i].addEventListener("touchend", mouseenterFunc);
    }

    for (let i = 0; i < links.length; i++) {
      links[i].style.opacity = "1";
    }
    links[0].classList.add("active");
    links[0].classList.add("active-col");
    links[0].style.opacity = "1";
    
    // const width = links[0].getBoundingClientRect().width;
    // const left = links[0].getBoundingClientRect().left + window.pageXOffset;

    const width = (links[0].getBoundingClientRect().width-58);
    const left = (links[0].getBoundingClientRect().left + window.pageXOffset+27);
    const top = links[0].getBoundingClientRect().top + window.pageYOffset;

    target.style.width = `${width}px`;
    target.style.left = `${left}px`;
    target.style.transition="all 2s ease-in-out";
    target.style.top=`${top}px`;


    function mouseOutFunction(){
      //colocar el coloreado en el elemento que esta activo
      for (let i = 0; i < links.length; i++) {
          links[i].style.opacity = "1";
          links[i].classList.remove("active-col");
      }
      const activo = document.querySelector(".active");
      activo.style.opacity="1";
      activo.classList.add("active-col");
      // const width = activo.getBoundingClientRect().width;
      // const left = activo.getBoundingClientRect().left + window.pageXOffset;
      const width = (activo.getBoundingClientRect().width-58);
      const left = (activo.getBoundingClientRect().left + window.pageXOffset+27);
      const top = activo.getBoundingClientRect().top + window.pageYOffset;
      // const height = this.getBoundingClientRect().height;

      target.style.width = `${width}px`;
      target.style.left = `${left}px`;
      target.style.transition="all .4s ease-in-out";
      target.style.top=`${top}px`;


    }

    function mouseenterFunc() {
      if (!this.classList.contains("active")) {
        for (let i = 0; i < links.length; i++) {
          if (links[i].classList.contains("active")) {
            links[i].classList.remove("active-col");
          }
          links[i].style.opacity = "1";
        }
        
        this.classList.add("active-col");
        this.style.opacity = "1";
        
        // const width = this.getBoundingClientRect().width;
        // const left = this.getBoundingClientRect().left + window.pageXOffset;

        const width = (this.getBoundingClientRect().width-58);
        const left = (this.getBoundingClientRect().left + window.pageXOffset+27);
        const top = this.getBoundingClientRect().top + window.pageYOffset;

        target.style.width = `${width}px`;
        target.style.left = `${left}px`;
        target.style.transition="all .4s ease-in-out";
        target.style.top=`${top}px`;
        target.style.position="absolute";
      }
    }

    window.addEventListener("resize", resizeFunc);
    function resizeFunc() {
      const active = document.querySelector(".mynav a.active");
      
      if (active) {
        // const left = active.getBoundingClientRect().left + window.pageXOffset;
        const left = (active.getBoundingClientRect().left + window.pageXOffset+27);
        const top = active.getBoundingClientRect().top + window.pageYOffset;

        target.style.left = `${left}px`;
        target.style.top = `${top}px`;
      }
    }
  }
}
</script>

<style>

.panel-scroll{
  height: 700px; 
  width: 90%;
  margin-left: 5%;
}

/* .panel-scroll::-webkit-scrollbar{
  width: 7px;
}
.panel-scroll::-webkit-scrollbar-thumb{
  background:  #2ABECC;
  border-radius: 5px;
} */

.gallery-container{
  display: grid;
  grid-template-columns: repeat( 3,1fr);
  grid-auto-rows: 300px;
  /* grid-auto-rows: 207px; esta linea es vañida para colocar contain en lugar de cover */
  padding: 30px;
  grid-gap: 30px;
  max-width: 1800px;
  width: 95%;
  margin: auto;
}

.gallery__img{
  width: 100%;
  height: 100%;
  /* LA linea de max-heigh permite que la imagen solo llegue hasta ese punto y coloca el panel con imagenes disparejas */
  /* max-height: 600px;  */
  object-fit: cover;
  /* object-fit: contain; */
}

.gallery_item:nth-child(1){
  /* grid-row: 1/3; */
  grid-row-start: span 2;
}

.gallery_item:nth-child(3){
  /* grid-row: 1/3; */
  grid-row-start: span 2;
}

.gallery_item:nth-child(4){
  grid-row-start: span 2;
}

.gallery_item:nth-child(5){
  grid-row-start: span 1;
}

.gallery_item:nth-child(7){
  grid-row-start: span 2;
}

.gallery_item:nth-child(9){
  grid-row-start: span 2;
}

.gallery_item:nth-child(12){
  grid-row-start: span 2;
}

.gallery_item:nth-child(16){
  grid-row-start: span 2;
}

.gallery_item:nth-child(20){
  grid-row-start: span 2;
}

.gallery_item:nth-child(23){
  grid-row-start: span 2;
}

.gallery_item:nth-child(24){
  grid-row-start: span 2;
}

.gallery_item:nth-child(29){
  grid-row-start: span 2;
}
.gallery_item:nth-child(36){
  grid-row-start: span 2;
}

.gallery_item:hover{
  transform: scale(1.05);
}
.gallery_item:hover .gallery__img{
  filter: blur(4px);
}


.active-col{
  font-family: 'Gotham Bold Regular';
  /* font-weight: bold; */
}
.row-image1{
  align-content: center;
  flex-flow: column wrap !important;
  height: 100%;
  max-height: 4000px;
}

/* general class for blur and zoom transition */
.proyecto{
  /* margin-top: 2%;
  margin-left: 40px; */
  position: relative;
  align-content: center;
  /* padding: 20px; */

}

.img-proyecto{
  opacity: 1;
  display: block;
  width: 100%;
  height: 100%;
  transition: all .1s ease;
  backface-visibility: hidden;
}

.over-proyecto{
  width: 100%;
  height: 100%;
  background: #1d2b3cc9;
  opacity: 0;
  /* display: none; */
  transition: .5s ease;
  position: absolute;
  top: 0%;
  /* left: 50%; */
  /* transform: translate(-50%, -50%);
  -ms-transform: translate(-50%, -50%); */
  text-align: center;
  /* display: table-cell;
	vertical-align: middle; */
}

.proyecto:hover{
  transform: scale(1.05);
}

.proyecto:hover .img-proyecto {
  filter: blur(4px);
}

.proyecto:hover .over-proyecto {
  /* display: block; */
  opacity: 1;
}


.name-project{
  font-family: 'Gotham Book Regular';
  letter-spacing: 1.2px;
  font-size: 18px;
  line-height: 23px;
  color:white;
  /* margin-top: 10%; */
  padding:15px;
  /* margin-bottom: 10px !important; */
}

.over-proyecto .name-service{
  font-family: 'Gotham light Regular';
    letter-spacing: 0;
    font-size: 12px;
    line-height: 16px;
    color:white;
    /* margin-bottom: 5px; */
}

.p-info-l{
  margin: auto;
  text-align: center;
  transition: margin 0.3s;
  -webkit-transition: margin 0.3s;
  margin-top: 150%;

}

.p-info-s{
  margin: auto;
  text-align: center;
  transition: margin 0.3s;
  -webkit-transition: margin 0.3s;
  margin-top: 50%;

}

/* .p-info-l{
  margin: auto;
  text-align: center;
  transition: margin 0.3s;
  -webkit-transition: margin 0.3s;
  margin-top: 50%;

} */

.proyecto:hover .p-info-s {
  margin-top: 30%;
}

.proyecto:hover .p-info-l {
  margin-top: 80%;
}

.index-li{
  z-index: 1;
}
.space50{
  margin-top: 60px;
}
.space100{
  margin-top: 120px;
}
.space10{
  margin-top: 10px;
}
.section-port{
  background: #E6E6E5;
  width:100%;
  height: 100%;
  padding-top: 7%;
}

.letter-book{

    font-family: 'Gotham Book Regular';
    letter-spacing: 1.23px;
    font-size: 14px;
    line-height: 30px;
    color:#1D2B3C !important;
}


.mynav{
  display: flex;
  justify-content: center;
  flex-flow: row wrap;
  list-style-type: none;
  padding-top: 1%;
}
 
/* .mynav a {
  display: block;
  text-decoration: none !important;
  padding: 2px 7px;
  color: #1D2B3C;
  z-index:-1;
} */

.mynav a {
  color: #1D2B3C;
  text-align: center;
  text-decoration: none;
  padding: 5px 18px;
  display: inline-block;
}

.mynav a:hover {
  color: #1D2B3C !important;
}

/* .target {
  position: absolute;
  border-bottom: 4px solid transparent;
  transform: translateX(-60px);
  color: #22C3D1;
  border-color: #22C3D1
} */

.target{
  background-color: #22C3D1;
  margin: 0;
  height: 3px;
  width: 68.25px;
  /* position: relative; */
  margin-top: 34px;
  position: absolute;
}
 
.mynav a,
.target {
  transition: all .1s ease-in-out;
}


/* .proyecto:hover{
    filter: blur(3px);
    opacity: .5;
}  */


/* .name-project{
    font-family: 'Gotham Book Regular';
    position: absolute;
    letter-spacing: 1.23px;
    font-size: 16px;
    line-height: 30px;
    color:#1D2B3C;
    z-index: 2;
} */

@media screen and (max-width: 2000px) and (min-width: 1700px){

  .gallery-container{
    display: grid;
    grid-template-columns: repeat( 4,1fr);
    grid-auto-rows: 350px;
    padding: 20px;
    grid-gap: 30px;
    max-width: 1800px;
    width: 95%;
    margin: auto;
  }

  .gallery__img{
    width: 100%;
    height: 100%;
    /* LA linea de max-heigh permite que la imagen solo llegue hasta ese punto y coloca el panel con imagenes disparejas */
    /* max-height: 600px;  */
    object-fit: cover;
    /* object-fit: contain; */
  }
  .row-image1{
    align-content: center;
    flex-flow: column wrap !important;
    height: 90%;
    max-height: 7200px;
  }

  .panel-scroll{
    height: 900px;
    width: 90%; 
  }

  .proyecto{
  margin-top: 1.5%; 
  margin-left: 1.5%;
  margin-right: 1.5%;
  position: relative;
  align-content: center;
  /* padding: 30px; */

}
  .letter-book{

    font-family: 'Gotham Book Regular';
    letter-spacing: 1.54px;
    font-size: 18px;
    line-height: 21px;
    color:#1D2B3C !important;
  }

  .over-s .name-project{
    font-family: 'Gotham light Regular';
    letter-spacing: 2.46px;
    font-size: 18px;
    line-height: 22px;
    color:white;
    /* margin-top: 10%; */
  }
  .over-l .name-project{
    font-family: 'Gotham light Regular';
    letter-spacing: 2px;
    font-size: 18px;
    line-height: 22px;
    color:white;
    text-align: center;
    padding: 21px;
    /* margin-top: 50%; */
  }

  .over-proyecto .name-service{
    font-family: 'Gotham light Regular';
      letter-spacing: 0;
      font-size: 18px;
      line-height: 22px;
      color:white;
  }

  .p-info-l{
    margin: auto;
    text-align: center;
    transition: margin 0.3s;
    -webkit-transition: margin 0.3s;
    margin-top: 100%;

  }

  .p-info-s{
    margin: auto;
    text-align: center;
    transition: margin 0.3s;
    -webkit-transition: margin 0.3s;
    margin-top: 35%;

  }

  .proyecto:hover .p-info-s {
      margin-top: 22%;
  }

  .proyecto:hover .p-info-l {
    margin-top: 50%;
  }

}

@media screen and (max-width: 960px) and (min-width: 100px){

  .gallery-container{
    display: grid;
    grid-template-columns: repeat( 2,1fr);
    grid-auto-rows: 130px;
    padding: 5px;
    /* grid-gap: 10px; */
    max-width: 1800px;
    width: 90%;
    margin: auto;
  }

  .gallery__img{
    width: 100%;
    height: 100%;
    max-height: 270px;
    /* object-fit: contain; */
    object-fit: cover;

  }

  .proyecto{
    position: relative;
    align-content: center;
    /* padding: 20px; */
  }

  .row-image{
    align-content: center;
    flex-flow: column wrap !important;
    height: 90%;
    max-height: 3200px;
  }

  .over-proyecto .name-project{
    font-family: 'Gotham Medium Regular';
    letter-spacing: 1px;
    font-size: 10px;
    line-height: 15px;
    color:white;
    padding: 10px;
  } 

  /* .over-l .name-project{
    font-family: 'Gotham light Regular';
    letter-spacing: 1px;
    font-size: 10px;
    line-height: 15px;
    color:white;
    margin-top: 2%;
  } */

  .over-proyecto .name-service{
    font-family: 'Gotham Medium Regular';
      letter-spacing: 0;
      font-size: 8px;
      line-height: 13px;
      color:white;

  }

  .p-info-l{
    margin: auto;
    text-align: center;
    transition: margin 0.3s;
    -webkit-transition: margin 0.3s;
    margin-top: 100%;

  }

  .p-info-s{
    margin: auto;
    text-align: center;
    transition: margin 0.3s;
    -webkit-transition: margin 0.3s;
    margin-top: 25%;

  }

  .proyecto:hover .p-info-s {
      margin-top: 10%;
  }

  .proyecto:hover .p-info-l {
    margin-top: 65%;
  }

.mynav{
  display: block;
  white-space: nowrap;
  padding-left: 25px;
  /* scrollbar-color: transparent transparent;
  overflow: hidden !important; */
  /* overflow-wrap: break-word; */
  /* overflow-x: inherit; */
}
.mynav.scrollmenu {
  /* overflow: auto; */
  /* white-space: nowrap; */
  overflow: hidden !important;
}

.mynav.scrollmenu a {
  display: inline-block;
  text-align: center;
  padding: 16px;
  text-decoration: none;
}

.target{
  margin-top: 36px;
  display: none;
}

.panel-scroll{
  height: 400px; 
  /* overflow-x: hidden; 
  overflow-y: scroll; */
  width: 80%;
  margin-left: 10%;
}



}
</style>